import React from 'react';
import { UI_Modal } from "../../../UiComponents/index";

function PaymentTypeModal(props) {
    const {
        isPaymentTypeModalOpen,
        setIsPaymentTypeModalOpen,
        oneTime,
        setOneTime,
        subcriptions,
        setSubcriptions,
        setisStripeOpen
    } = props;

    const HandleCheck = (checkName) => {
        console.log(checkName);
        if (checkName === "oneTime") {
            setOneTime(!oneTime)
            setSubcriptions(false)
            setIsPaymentTypeModalOpen(false)
            setisStripeOpen(true)
        }
        if (checkName === "subcriptions") {
            setSubcriptions(!subcriptions)
            setOneTime(false)
            setIsPaymentTypeModalOpen(false)
            setisStripeOpen(true)
        }
    }
    return (
        <>
            <UI_Modal
                isOpen={isPaymentTypeModalOpen}
                closeModal={() => setIsPaymentTypeModalOpen(false)}
                title={'Select Pyament Type'}
            >
                <div className="flex px-2 py-2  m-3 sccess_text items-start text-white">
                    <div className="sccess_text">
                        <div className="Check">
                            <label>
                                <input type="checkbox" onChange={() => HandleCheck("oneTime")} />
                                <svg
                                    className={`checkbox ${oneTime ? "checkbox--active" : ""}`}
                                    aria-hidden="true"
                                    viewBox="0 0 15 11"
                                    fill="none"
                                >
                                    <path
                                        d="M1 4.5L5 9L14 1"
                                        strokeWidth="3"
                                        stroke={oneTime ? "#141416" : "none"}
                                    />
                                </svg>
                                {<span className="Lebel">{"One Time"}</span>}
                            </label>
                        </div>
                        <div className="Check">
                            <label>
                                <input type="checkbox" onChange={() => HandleCheck("subcriptions")} />
                                <svg
                                    className={`checkbox ${subcriptions ? "checkbox--active" : ""}`}
                                    aria-hidden="true"
                                    viewBox="0 0 15 11"
                                    fill="none"
                                >
                                    <path
                                        d="M1 4.5L5 9L14 1"
                                        strokeWidth="3"
                                        stroke={subcriptions ? "#141416" : "none"}
                                    />
                                </svg>
                                {<span className="Lebel">{"Subcriptions"}</span>}
                            </label>
                        </div>
                    </div>
                </div>
            </UI_Modal>
        </>
    )
}

export default PaymentTypeModal